import React from 'react';
import Images from '../../../Configs/images';
import Carousel from '../../Elements/Carousel';

export default function Component() {
  const data = [
    Images.TestImg,
    Images.TestImg,
    Images.TestImg,
    Images.TestImg,
  ];
  return (
    <Carousel data={data} itemWidth={0.9} />
  );
}
